import React, { useEffect, useRef, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import { PRCDropDown } from '../controls/prcdropdown.js';
import "../../css/main.css"
import { useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';
import { PRCInput } from '../controls/prcinput.js';


export function AdminSearchForm() {

    const [pageData, setPageData] = useState();
    const [totalPages, setTotalPages] = useState(0);
    const [memberList, setMemberList] = useState([]);
    const [memberStatus, setMemberStatus] = useState(0);
    const [memberType, setMemberType] = useState(0);
    const [membershipTypeData, setMembershipTypeData] = useState(["Status - All"]);
    const [membershipstatuses, setMembershipStatuses] = useState(["TYPE : ALL"]);
    const [allActiveMembers, setAllActiveMembers] = useState(false);
    const [cardTemplates, setCardTemplates] = useState([]);
    const [cardTemplate, setCardTemplate] = useState(-1);


    let page_number = useRef(1);
    let first_render = useRef(true);

    const handleDataFetch = (data) => {
        setPageData(data);
        let stats = data.components.membershipstatuses;
        stats.unshift({ id: 0, description: "Status : All" });

        let types = data.components.membershiptypes;
        types.unshift({ id: 0, description: "TYPE : ALL" });
        setMembershipStatuses(stats);
        setMembershipTypeData(types);
    }
    const navigate = useNavigate();
    const { MakeCall } = useAPICall();

    useEffect(() => {
        MakeCall('admin/getadminpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
        if (first_render.current === true) {
            let status = sessionStorage.getItem('idpeveril_status') || 0;
            let type = sessionStorage.getItem('idpeveril_member_type') || 0;
            document.getElementById('search_phrase').value = sessionStorage.getItem('search_phrase');
            document.getElementById('idpeveril_status').value = status;
            document.getElementById('idpeveril_member_type').value = type;
            page_number.current = 1;
            setMemberType(type);
            setMemberStatus(status);
            MemberSearch(status, type);
            first_render.current = false;
        }

    });


    function handleShowMember(id) {
        navigate("/ViewMember", { state: { memberID: id } });
    }

    function handleMemberSeachComplete(data) {
        if (data) {
            if (data.components) {
                const members = data.components['members'];
                if (members) {

                    setTotalPages(members.total_pages);
                    setMemberList(members.member_list);
                }
                if(data.components['cardtemplates'] != null)
                {
                setCardTemplates(data.components['cardtemplates']);
                if(data.components['cardtemplates'].length > 0)
                {
                    handleTemplateChange(data.components['cardtemplates'][0].id);
                }
            }
            }
        }

    }
    function handleNav(destination, state) {
        navigate(destination, state);
    }

    function MemberSearch(pmemberStatus, pmemberType) {
        let search_phrase = document.getElementById('search_phrase').value;
       

        MakeCall('admin/getmembersearch', "{ \"token\" : \"" + sessionStorage.getItem("Token") +
            "\", \"search_phrase\" : \"" + search_phrase +
            "\", \"page\":\"" + page_number.current +
            "\", \"membership_type\":\"" + pmemberType +
            "\", \"membership_status\":\"" + pmemberStatus +
            "\"}", handleMemberSeachComplete, true);
    }

    function handleMemberSearch() {
        page_number.current = 1;
        sessionStorage.setItem("search_phrase", document.getElementById('search_phrase').value);
        sessionStorage.setItem("idpeveril_status", document.getElementById('idpeveril_status').value);
        sessionStorage.setItem("idpeveril_member_type", document.getElementById('idpeveril_member_type').value);
        
        MemberSearch(memberStatus, memberType);

    }

    function handleClearSearch() {
        page_number.current = 1;
        sessionStorage.setItem("search_phrase", '');
        sessionStorage.setItem("idpeveril_status",'');
        sessionStorage.setItem("idpeveril_member_type", '');
        document.getElementById('search_phrase').value = '';
        setMemberStatus(0);
        setMemberType(0);
        
        


        MemberSearch(0, 0);
    }
    function handleLoadPage(pageNo) {
        page_number.current = pageNo;
        sessionStorage.setItem("page_number", page_number.current);
        MemberSearch(memberStatus, memberType);
    }

    function DrawPages() {
        const result = [];
        if (totalPages > 0) {
            let startPage = page_number.current;
            let endPage = page_number.current + 4;
            const max_pages = 3;
            const page_diff = 1;
            let pre = '';
            let post = '';
            if(totalPages < max_pages)
            {
                endPage = totalPages;
            }
            else
            {
                if((page_number.current - page_diff) < 1)
                {
                    startPage = 1;
                    endPage = max_pages;
                }
                else if((page_number.current + page_diff) > totalPages)
                {
                    startPage = totalPages - max_pages;
                    endPage = totalPages;
                }               
                else
                {
                    startPage = page_number.current - page_diff;
                    endPage = page_number.current + page_diff;
                }
            }

            result.push(<div key='first' className='pagebutton' onClick={() => { handleLoadPage(1) }}>&lt;&lt;</div>);
            result.push(<div>{pre}</div>);
            for (let i = startPage; i <= endPage; i++) {
                if (page_number.current === i) {
                    result.push(<div className='pagesbarselected' key={i} onClick={() => { handleLoadPage(i) }}>{i}</div>);
                }
                else {
                    result.push(<div className='pagebutton' key={i} onClick={() => { handleLoadPage(i) }}>{i}</div>);
                }
            }
            result.push(<div>{post}</div>);
            result.push(<div key='last' className='pagebutton' onClick={() => { handleLoadPage(totalPages) }}>&gt;&gt;</div>);
        }
        return result;
    }

    function handleStatusChange(status) {
        setMemberStatus(status);
        
        sessionStorage.setItem("idpeveril_status", status);
        
        MemberSearch(status, memberType);

    }

    function handleTypeChange(type) {
        setMemberType(type);        
        sessionStorage.setItem("idpeveril_member_type", type);
        MemberSearch(memberStatus, type);
    }

    function handlePrintMembershipCards()
    {
          var cardexpiry = document.getElementById("cardexpiry").value;
          let search_phrase = document.getElementById('search_phrase').value;
          MakeCall('admin/printmembershipcards', "{ \"token\" : \"" + sessionStorage.getItem("Token") +
              "\", \"search_phrase\" : \"" + search_phrase +
              "\", \"page\":\"0" + 
              "\", \"membership_type\":\"" + memberType +
              "\", \"membership_status\":\"" + memberStatus +
              "\", \"all_active_members\":\"" + allActiveMembers +
              "\", \"card_expiry\":\"" + cardexpiry +
              "\", \"idtemplate\":\"" + cardTemplate  +
              "\"}", handlePrintCardComplete, true);
    }

    function handleTemplateChange(template) {
        setCardTemplate(template);        
        sessionStorage.setItem("idtemplate", template);
    }

    function handlePrintCardComplete(data) {
        if (data.components['cardresult'].result === true) {
          var carddata = data.components['cardresult'].carddata;
           var blob = new Blob([base64ToArrayBuffer(carddata)], {type: "application/pdf"});
           var link = document.createElement('a');
           link.href = window.URL.createObjectURL(blob);
        
           link.download = data.components['cardresult'].filename;
           link.click();
        }
        document.getElementById("printcardform").style.display = "none"
    }
   
    function handleAllActiveChange()
    {
        const tempEl = document.getElementById("peveril_all_members");
        setAllActiveMembers(document.getElementById("peveril_all_members").checked);
    }

    function ShowPrintCard() {
  
        return (
            <div className='popup_form' id="printcardform">
                <h1>Print Membership Card</h1>              
                <p>This function will create a PDF of membership cards for all members filtered by the current search.</p>
                <p>If the expiry date is entered, this will be used, if it is left blank the expiry date will be taken from the card template</p>
                <div className='formrow' >
                    <div className='formlabel' style={{ "width": "30%" }}>
                        Card Template
                    </div>                    
                    <div className='formvalue'>
                    <PRCDropDown id='peverilCardTemplate' className='logininput' name='CARD_TEMPLATE' placeholder="Card Template" 
                    options={cardTemplates} value={cardTemplate} onChange={handleTemplateChange} /> 
                    </div>                  
                </div>
                <div className='formrow'>
                    <div className='formlabel' style={{ "width": "30%" }}>
                        Expiry
                    </div>
                    <div className='formvalue'>
                       <PRCInput id='cardexpiry' className='logininput' />
                    </div>                  
                </div>
                <div className='formrow'>
                    <div className='formlabel' style={{ "width": "30%" }}>
                        All active members
                    </div>
                    <div className='formvalue'>
                    
                        <input className='prccheckbox' type='checkbox' id='peveril_all_members' name='ALL_ACTIVE_MEMBERS' value={allActiveMembers} onChange={handleAllActiveChange}></input>
                    </div>                  
                </div>                
                <div className='formrowcentered'  style={{"width":"100%"}}>              
                <div className='formlabel'>
                  <input type='button' className='prcbtn' value='Print' onClick={handlePrintMembershipCards} />
                </div>
                <div className='formlabel'>
                  <input type='button' className='prcbtn' value='Cancel' onClick={() => { document.getElementById("printcardform").style.display = "none" }} />
                </div>    
                </div>
            </div>);
    
  }
  

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'addnewmember':
                handleNav('/AdminNewMember');
                break;
            case 'manageyears':
                handleNav('/AdminYears');
                break;
            case 'managefamilies':
                handleNav('/AdminFamilies');
                break;
            case 'uploadposfile':
                handleNav('/AdminPosUpload');
                break;      
            case 'printmembershipcards':
                if (document.getElementById("printcardform")) {
                    document.getElementById("printcardform").style.display = "block";
                }
                break;   
            case 'reports':
                handleNav('/AdminReports');
                
                break;
                default:
                    break;
        }
    }

    function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
           var ascii = binaryString.charCodeAt(i);
           bytes[i] = ascii;
        }
        return bytes;
     }


    document.onkeydown = keyPress;

    function keyPress(e){
      var x = e || window.event;
      var key = (x.keyCode || x.which);
      if(key === 13 || key === 3){
       //  myFunc1();
       handleMemberSearch();
      }
    }

    return (
        <div>
            {SecurityElement(pageData)}
            {MenuForm()}
            {ShowPrintCard()}
            <div className="contentdiv">
                {PageMenuElement("Admin", [{ "name": "Add New Member", "onclick": "addnewmember", "permission_name":"UpdateMember" },
                { "name": "Manage Years", "onclick": "manageyears", "permission_name":"UpdateYears" },
                { "name": "Manage Families", "onclick": "managefamilies", "permission_name":"ViewFamilies" },
                { "name": "Upload POS File", "onclick": "uploadposfile", "permission_name":"UpdateMember" },
                { "name": "Print Membership Cards", "onclick": "printmembershipcards", "permission_name":"UpdateMember" },
                { "name": "Reports", "onclick": "reports" }], onPageMenuClick)}
                <div id='AdminForm' style={{ "display": "block" }}>
                                
                    <div id='ViewMembers' >
                        <div className='formbox'>
                            <div className='formtitle'>Search Members</div>
                            <div className='searchbox'>
                                <div className='searchboxitem' style={{ "width": "60%" }}>
                                    <input id="search_phrase" className='logininput' placeholder='Search Text'></input>

                                </div>
                                <div className='searchboxitem' style={{ "width": "20%" }}>
                                    <PRCDropDown id='idpeveril_status' className='logininput' name='MEMBER_DATA' placeholder="Member Status" options={membershipstatuses} value={memberStatus} onChange={handleStatusChange} />
                                </div>
                                <div className='searchboxitem' style={{ "width": "20%" }}>
                                    <PRCDropDown id='idpeveril_member_type' className='logininput' name='MEMBER_DATA' placeholder="Member Type" options={membershipTypeData} value={memberType} onChange={handleTypeChange} />
                                </div>
                              
                            </div>
                            <div className='searchbox'>
                            </div>
                            <div className='pagesbar'>
                                <div className='searchboxitem' style={{ "width": "50%" }}>
                                    <button type="button" className='prcbtn' onClick={handleMemberSearch}>Search</button>
                                </div>
                                {DrawPages()}
                                <div className='searchboxitem' style={{ "width": "50%" }}>
                                    <button type="button" className='prcbtn' onClick={handleClearSearch}>Clear</button>
                                </div>
                            </div>
                            <div className='gridrow' key={"header"} >
                                <div className='gridcolumn' style={{ "width": "30%" }}>Num</div>
                                <div className='gridcolumn' style={{ "width": "50%" }}>Name</div>
                                <div className='gridcolumn' style={{ "width": "30%" }}>Type</div>
                            </div>
                            {memberList.map((member) => (
                                <div key={member.membership_number} className='gridrow' onClick={() => { handleShowMember(member.idpeveril_member) }}>
                                    <div className='gridcell' style={{ "width": "30%" }}>{member.membership_number}</div>
                                    <div className='gridcell' style={{ "width": "50%" }}>{member.forename + " " + member.surname}</div>
                                    <div className='gridcell' style={{ "width": "30%" }}>{member.peveril_membership_type}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>

            </div>
        </div>


    );
}
